import { render, staticRenderFns } from "./SurveyResultsPanel.vue?vue&type=template&id=493e8a9b&scoped=true"
import script from "./SurveyResultsPanel.vue?vue&type=script&lang=js"
export * from "./SurveyResultsPanel.vue?vue&type=script&lang=js"
import style0 from "./SurveyResultsPanel.vue?vue&type=style&index=0&id=493e8a9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e8a9b",
  null
  
)

export default component.exports